import { usePagedCollection } from '../../../entities/utils/collections';
import * as Api from '@ViewModels';

export const useIssuesLog = (userSession: Api.UserSessionContext) => {
	const { fetching, items, getItems, setItems } = usePagedCollection<
		Api.ICoffeeLeadIssueView,
		Api.ICoffeeLeadIssueView,
		Api.ICoffeeLeadIssueFilter
	>(userSession, {
		apiPath: 'coffeeleadissue/filter',
	});

	return { fetching, getItems, items, setItems } as const;
};
